module.exports = __webpack_public_path__ + "static/infrared-100-204b535ca68a412dd67f31422209ca8a.png";